// @flow
import React from 'react';
import Lottie from 'react-lottie';
import dateRangeGif from 'src/assets/json/merchandising/gif-date-range.json';
import { HomeMajor, ProductsMajor, CollectionsMajor, CheckoutMajor } from '@shopify/polaris-icons';

export * from './rule';

// Product tour config for rule page
export const defaultOptions = gif => ({
  loop: true,
  autoplay: true,
  animationData: gif
});
export const COLUMN_WIDGET = [
  { value: 'name', label: 'column3_Title', textAlign: 'left', width: 27, width2: 26 },
  { value: 'status', label: 'column1_Title', textAlign: 'left', width: 12, width2: 11 },
  { value: 'widgetId', label: 'column2_Title', textAlign: 'left', width: 27, width2: 24 },
  { value: 'type', label: 'column4_Title', textAlign: 'left', width: 24, width2: 23 },
  { value: 'actions', label: 'column6_Title', textAlign: 'center', width: 10, width2: 16 }
];

export const PERSONALIZED_RECOMMENDATION = 'personalized-recommendation';

// List of page type for recommendation widget
export const RECOMMENDATION_WIDGET_PAGE_TYPES = {
  'home-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_Homepage_Label',
    icon: HomeMajor
  },
  'product-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_ProductPage_Label',
    icon: ProductsMajor
  },
  'collection-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CollectionPage_Label',
    icon: CollectionsMajor
  },
  'cart-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CartPage_Label',
    icon: CheckoutMajor
  },
  'checkout-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CheckoutPage_Label',
    icon: CheckoutMajor
  }
};

// List of recommendation type for recommendation widget
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES = {
  bestsellers: {
    value: 'bestsellers',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Description',
    hasSettings: true
  },
  'newest-arrivals': {
    value: 'newest-arrivals',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Description',
    hasSettings: false
  },
  'frequently-bought-together': {
    value: 'frequently-bought-together',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Description',
    hasSettings: true,
    isAIPowered: true
  },
  'trending-products': {
    value: 'trending-products',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_TrendingProducts_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_TrendingProducts_Description',
    hasSettings: true
  },
  'hand-picked-products': {
    value: 'hand-picked-products',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_HandPickedProducts_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_HandPickedProducts_Description',
    hasSettings: true
  },
  'recently-viewed': {
    value: 'recently-viewed',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyViewed_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyViewed_Description',
    hasSettings: false
  },
  'most-viewed': {
    value: 'most-viewed',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Description',
    hasSettings: false
  },
  'related-items': {
    value: 'related-items',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RelatedItems_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_RelatedItems_Description',
    hasSettings: true,
    isAIPowered: true
  },
  'recently-purchased': {
    value: 'recently-purchased',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyPurchased_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_RecentlyPurchased_Description',
    hasSettings: false
  },
  'personalized-recommendation': {
    value: PERSONALIZED_RECOMMENDATION,
    name: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_Label',
    defaultName: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_DefaultName',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_Description',
    hasSettings: true,
    isAIPowered: true
  }
};
// List of recommendation type per page type for recommendation widget
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES_WITH_PAGE_TYPES = {
  'home-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'newest-arrivals': { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: false, premium: true },
    'most-viewed': { mostUsed: false, premium: true }
  },
  'product-page': {
    'frequently-bought-together': { mostUsed: true, premium: true },
    'related-items': { mostUsed: true, premium: true },
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true },
    'trending-products': { mostUsed: false, premium: true }
  },
  'collection-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true }
  },
  'cart-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'frequently-bought-together': { mostUsed: true, premium: true },
    'related-items': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true }
  },
  'checkout-page': {
    'personalized-recommendation': { mostUsed: false, premium: true, comingSoon: false },
    'frequently-bought-together': { mostUsed: false, premium: true },
    'related-items': { mostUsed: false, premium: true },
    'recently-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'hand-picked-products': { mostUsed: false, comingSoon: true }
  }
};

// List of recommendation type per page type for recommendation widget for freemium
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES_WITH_PAGE_TYPES_FOR_FREEMIUM = {
  'home-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: false, premium: true, enableDefault: true }
  },
  'product-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'frequently-bought-together': { mostUsed: true, premium: true, enableDefault: false },
    'related-items': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    'most-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: true, premium: true, enableDefault: true },
    bestsellers: { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true },
    'trending-products': { mostUsed: false, premium: true, enableDefault: true }
  },
  'collection-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true }
  },
  'cart-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'frequently-bought-together': { mostUsed: true, premium: true, enableDefault: false },
    'related-items': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true }
  },
  'checkout-page': {
    'personalized-recommendation': { mostUsed: false, premium: true, comingSoon: false },
    'frequently-bought-together': { mostUsed: false, premium: true },
    'related-items': { mostUsed: false, premium: true },
    'recently-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'hand-picked-products': { mostUsed: false, comingSoon: true }
  }
};

export const RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_DATE_RANGE = [
  { value: '7', label: 'AdminHTML.Recommendation.Constants.dateRange_7' },
  { value: '6', label: 'AdminHTML.Recommendation.Constants.dateRange_6' },
  { value: '5', label: 'AdminHTML.Recommendation.Constants.dateRange_5' },
  { value: '4', label: 'AdminHTML.Recommendation.Constants.dateRange_4' },
  { value: '3', label: 'AdminHTML.Recommendation.Constants.dateRange_3' },
  { value: '2', label: 'AdminHTML.Recommendation.Constants.dateRange_2' },
  { value: '1', label: 'AdminHTML.Recommendation.Constants.dateRange_1' }
];

export const RECOMMENDATION_AI_BASED_FBT_PRIMARY_OPTIONS = [
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_FBT', value: 'FBT' }
];

export const RECOMMENDATION_AI_BASED_FBT_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_BESTSELLERS_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  }
];

export const RECOMMENDATION_AI_BASED_PERSONALIZED_PRIMARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Personalized',
    value: PERSONALIZED_RECOMMENDATION
  }
];

export const RECOMMENDATION_AI_BASED_PERSONALIZED_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Label',
    value: 'FBT'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_PRIMARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'alternative-products',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative_Helper'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'complementary-products',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary_Helper'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Both',
    value: 'both',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Both_Helper'
  }
];

export const RECOMMENDATION_AI_BASED_RELATED_ALTERNATIVE_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_COMPLEMENTARY_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_BOTH_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_BASED_ON_TYPES = [
  { value: 'view-events', label: 'AdminHTML.Recommendation.Constants.trendingProductBasedOn_View' },
  {
    value: 'purchase-events',
    label: 'AdminHTML.Recommendation.Constants.trendingProductBasedOn_Purchase'
  }
];

export const RECOMMENDATION_WIDGET_AI_BASED_RECOMMENDATION_TYPES = [
  {
    value: 'complementary-products',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary_t1',
        type: 'strong'
      },
      {
        name: 't2',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary_t2',
        type: 'strong'
      }
    ]
  },
  {
    value: 'alternative-products',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative_t1',
        type: 'strong'
      },
      {
        name: 't2',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative_t2',
        type: 'strong'
      }
    ]
  },
  {
    value: 'both',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Both',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Both_t1',
        type: 'strong'
      }
    ]
  }
];

export const RECOMMENDATION_WIDGET_LIMIT_RULE_BASED_RECOMMENDATION = 4;

export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES = {
  SAME_COLLECTION: 'sameCollection',
  SAME_PRODUCT_CATEGORY: 'sameProductCategory',
  SAME_PRODUCT_TYPE: 'sameProductType',
  SAME_VENDOR: 'sameVendor',
  SAME_TAGS: 'sameTags',
  SAME_METAFIELD_1: 'sameMetafield_1',
  SAME_METAFIELD_2: 'sameMetafield_2',
  SAME_METAFIELD_3: 'sameMetafield_3'
};
export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES_LABEL = {
  sameCollection: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameCollection',
  sameProductCategory:
    'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameProductCategory',
  sameProductType: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameProductType',
  sameVendor: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameVendor',
  sameTags: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameTags',
  sameMetafield_1: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_1',
  sameMetafield_2: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_2',
  sameMetafield_3: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_3'
};

export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES_DEFAULT = [
  { type: 'sameCollection', status: false },
  { type: 'sameProductCategory', status: false },
  { type: 'sameProductType', status: false },
  { type: 'sameVendor', status: false },
  { type: 'sameTags', status: false },
  { type: 'sameMetafield_1', status: false },
  { type: 'sameMetafield_2', status: false },
  { type: 'sameMetafield_3', status: false }
];

export const RECOMMENDATION_WIDGET_LIMIT_RULE_GROUPS = {
  'product-page': 150,
  'home-page': 1,
  'collection-page': 150,
  'cart-page': 1,
  'checkout-page': 0
};
export const LIMIT_CONDITION_PRODUCTS_PER_RULE_BY_RECOMMENDATION_TYPE = {
  'hand-picked-products': 15,
  bestsellers: 15
};
export const LIMIT_CONSEQUENCE_PRODUCTS_PER_RULE_BY_RECOMMENDATION_TYPE = {
  'hand-picked-products': 15,
  bestsellers: 5
};
export const RECOMMENDATION_WIDGET_RULE_GROUP_PRODUCT_OPTIONS = [
  { value: 'product_id', label: 'AdminHTML.Recommendation.Constants.productOption01_Label' },
  { value: 'collection_id', label: 'AdminHTML.Recommendation.Constants.productOption02_Label' }
];
export const DESIGN_STYLE_SETTINGS = [
  {
    value: 'default',
    label: 'AdminHTML.Recommendation.VisualEditor.designStyleSettings_Option01'
  },
  {
    value: 'customization',
    label: 'AdminHTML.Recommendation.VisualEditor.designStyleSettings_Option02'
  }
];

export const TEXT_ALIGNMENT = [
  {
    value: 'left',
    label: 'AdminHTML.Recommendation.Constants.textAlignment01_Label'
  },
  {
    value: 'center',
    label: 'AdminHTML.Recommendation.Constants.textAlignment02_Label'
  }
];

export const TEXT_TRANSFORM = [
  {
    value: 'none',
    label: 'AdminHTML.Recommendation.Constants.textTransform01_Label'
  },
  {
    value: 'uppercase',
    label: 'AdminHTML.Recommendation.Constants.textTransform02_Label'
  },
  {
    value: 'capitalize',
    label: 'AdminHTML.Recommendation.Constants.textTransform03_Label'
  },
  {
    value: 'lowercase',
    label: 'AdminHTML.Recommendation.Constants.textTransform04_Label'
  }
];

export const FONT_STYLE = [
  {
    value: 'regular',
    label: 'AdminHTML.Recommendation.Constants.fontStyle01_Label'
  },
  {
    value: 'italic',
    label: 'AdminHTML.Recommendation.Constants.fontStyle02_Label'
  }
];

export const LAYOUT_DISPLAY = [
  {
    value: 'carousel',
    maxNumberProductInWidget: 30,
    defaultMaxNumberProductInWidget: 12,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice01_Label'
  },
  {
    value: 'grid',
    maxNumberProductInWidget: 5,
    defaultMaxNumberProductInWidget: 2,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice02_Label'
  },
  {
    value: 'bundle',
    maxNumberProductInWidget: 5,
    defaultMaxNumberProductInWidget: 2,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice03_Label'
  }
];

export const BUNDLE_STYLE = [
  {
    value: 'style1',
    label: 'AdminHTML.Recommendation.Constants.bundleStyle01_Label'
  },
  {
    value: 'style2',
    label: 'AdminHTML.Recommendation.Constants.bundleStyle02_Label'
  }
];
export const MANUAL_RECOMMENDATION_TAB_TYPE = {
  SEARCH_RESULT: 'search-result',
  HAND_PICKED_PRODUCTS: 'hand-picked-products',
  FREQUENTLY_BOUGHT_TOGETHER: 'frequently-bought-together',
  RELATED_ITEMS: 'related-items'
};

export const MANUAL_RECOMMENDATION_TAB_ITEM = {
  [MANUAL_RECOMMENDATION_TAB_TYPE.SEARCH_RESULT]: {
    id: 'search-result',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab1_Title',
    panelID: 'search-result'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.HAND_PICKED_PRODUCTS]: {
    id: 'hand-picked-products',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab2_Title',
    panelID: 'hand-picked-products'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.FREQUENTLY_BOUGHT_TOGETHER]: {
    id: 'frequently-bought-together',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab3_Title',
    panelID: 'frequently-bought-together'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.RELATED_ITEMS]: {
    id: 'related-items',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab4_Title',
    panelID: 'related-items'
  }
};

export const MANUAL_RECOMMENDATION_TABS = [
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.HAND_PICKED_PRODUCTS],
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.FREQUENTLY_BOUGHT_TOGETHER],
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.RELATED_ITEMS]
];

export const SEARCH_RESULT_MANUAL_RECOMMENDATION_TAB = 0;
export const HAND_PICKED_PRODUCT_TAB = 0;
export const FREQUENTLY_BOUGHT_TOGETHER_TAB = 1;
export const RELATED_ITEMS_TAB = 2;
export const NUMBER_RECOMMENDATION_PER_PAGE = 10;
export const LIMIT_SHOW_RECOMMENDATION_PRODUCT = 8;

export const NUMBER_PRODUCT = 15;
export const NUMBER_PRODUCT_PER_PAGE = 20;

export const AIML_MODEL_STATUS_BANNER_CONTENT = {
  // all
  'FBT_DONE-COMPLEMENTARY_DONE-ALTERNATIVE_DONE-AIRELATED_DONE': {
    type: 'done',
    group: 'AIModelBannerDone'
  },
  // end
  // related type
  'COMPLEMENTARY_DONE-ALTERNATIVE_DONE-AIRELATED_DONE': {
    type: 'done',
    group: 'AIModelBannerDone'
  },
  'COMPLEMENTARY_DONE-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'alternative'
  },
  'COMPLEMENTARY_DONE-ALTERNATIVE_PROCESSING-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'alternative'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'all'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_DONE-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'complementary'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_PROCESSING-AIRELATED_NOT_ENOUGH': {
    type: 'processing_notEnough',
    group: 'AIModelBannerProcessing_NotEnough',
    content: 'alternative'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_DONE-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'complementary'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'processing_notEnough',
    group: 'AIModelBannerProcessing_NotEnough',
    content: 'complementary'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_PROCESSING-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'all'
  },
  // end
  PROCESSING: {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'all'
  }
};

export const AIML_QUERY_INTERVAL_MILIS = 3000;

export const RECOMMENDATION_WIDGET_STATUS = [
  {
    value: 'live',
    label: 'AdminHTML.Recommendation.Constants.status_Live',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Live_Display'
  },
  {
    value: 'draft',
    label: 'AdminHTML.Recommendation.Constants.status_Draft',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Draft_Display'
  },
  {
    value: 'archive',
    label: 'AdminHTML.Recommendation.Constants.status_Archive',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Archive_Display'
  }
];

export const ACCENT_COLOR = '#003D2C';

// Product tour config for list rule page

export const CONFIG_RECOMMENDATION_WIDGETS_TOUR = (i18n: Object) => {
  return [
    {
      selector: '[data-tut="pfs_tour_widgets"]',
      content: () => (
        <div className="widgets-tour">
          <h2 className="heading-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep01_title')}
          </h2>
          <div style={{ backgroundColor: 'rgb(255 255 255)' }}>
            <Lottie options={defaultOptions(dateRangeGif)} width={400} height={200} />
          </div>
          <div className="content-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep01_content')}
          </div>
        </div>
      ),
      position: 'left',
      style: {
        backgroundColor: 'white',
        padding: 0,
        width: '400px',
        maxWidth: 'unset',
        color: 'black',
        borderRadius: '8px'
      }
    },
    {
      selector: '[data-tut="pfs_tour_actions"]',
      content: () => (
        <div className="widgets-tour">
          <h2 className="heading-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_title')}
          </h2>
          <div style={{ backgroundColor: '#F1F2F3' }}>
            <Lottie options={defaultOptions(dateRangeGif)} width={400} height={200} />
          </div>
          <div className="content-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_content', {
              t: (
                <strong variation="strong">
                  {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_content_t')}
                </strong>
              )
            })}
          </div>
        </div>
      ),
      position: 'left',
      style: {
        backgroundColor: 'white',
        padding: 0,
        width: '400px',
        maxWidth: 'unset',
        borderRadius: '8px',
        color: 'black'
      }
    }
  ];
};

export const TEST_MOVING_PRODUCT_DATA_SOURCE_STORES = [
  'boost-pfs-test-kaylee03.myshopify.com',
  'boost-pfs-test-kaylee04.myshopify.com',
  'bc-dev-v2-kaylee1.myshopify.com',
  'boost-pfs-test-kaylee01.myshopify.com',
  'bc-dev-v2-kaylee2.myshopify.com',
  'boost-pfs-test-tae-kaylee.myshopify.com',
  'boost-pfs-test-tae-recommend.myshopify.com',
  'boost-pfs-test-kaylee02.myshopify.com',
  'bc-dev-v2-kaylee3.myshopify.com',
  'bc-dev-v2-daisy01.myshopify.com'
];

export const TITLE_FONT_SIZE = [
  { value: 'x-small', label: 'Extra small' },
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Default' },
  { value: 'large', label: 'Medium' },
  { value: 'x-large', label: 'Large' },
  { value: 'xx-large', label: 'Extra large' }
];
